import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const PUBLIC_API_BASE = `${BACKEND_URL}/api/public`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("intercar_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  // Multi-store: when the owner has selected a specific store from the switcher,
  // every API call routes to that dealership. Backend validates it belongs to
  // the caller's owner_group_id before honouring the override.
  const activeDid = localStorage.getItem("intercar_active_dealership");
  if (activeDid) config.headers["X-Active-Dealership-Id"] = activeDid;
  return config;
});

export default api;

// -------- Multi-store helpers --------
// Persist the currently-selected dealership across page reloads. `null` clears
// the override → backend falls back to the JWT's default dealership_id.
export const getActiveDealershipId = () => localStorage.getItem("intercar_active_dealership") || null;
export const setActiveDealershipId = (id) => {
  if (id) localStorage.setItem("intercar_active_dealership", id);
  else localStorage.removeItem("intercar_active_dealership");
};

export const formatCurrency = (v, locale = "pt-BR", currency = "USD") =>
  new Intl.NumberFormat(locale, { style: "currency", currency, maximumFractionDigits: 0 }).format(v || 0);

// Regra da loja: lançamentos de dinheiro salvam sem centavos. Retorna o aviso
// de arredondamento quando o valor digitado tem centavos (senão null).
export const wholeDollarHint = (v) => {
  const n = Number(v);
  if (!n || !isFinite(n) || Number.isInteger(n)) return null;
  return `US$ ${n.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} será salvo como ${formatCurrency(Math.round(n))}`;
};

export const formatNumber = (v) => new Intl.NumberFormat("en-US").format(v || 0);

/**
 * Local "NEW ARRIVAL / PHOTOS COMING SOON" placeholder shown whenever a
 * vehicle has no real photos yet (or its only "photo" is actually the source
 * site's own placeholder).
 */
export const NO_PHOTO_PLACEHOLDER = "/no-photo-placeholder.png";

// Substrings frequently found inside placeholder image URLs / filenames coming
// from external dealer sites. If a vehicle's images[0] matches any of these
// we treat it as "no real photo" and render the local placeholder instead.
const _PLACEHOLDER_HINTS = [
  "preparacao", "preparação", "preparation", "coming-soon", "coming_soon",
  "comingsoon", "no-photo", "no_photo", "nophoto", "no-image", "noimage",
  "placeholder", "new-arrival",
];

const _isPlaceholderUrl = (u) => {
  if (!u || typeof u !== "string") return true;
  const ls = u.toLowerCase();
  return _PLACEHOLDER_HINTS.some((h) => ls.includes(h));
};

/**
 * Returns the best photo URL for a vehicle. Falls back to the local
 * "NEW ARRIVAL" placeholder if the only available image is itself a
 * source-site placeholder.
 */
export const vehiclePhoto = (vehicle) => {
  const imgs = (vehicle && vehicle.images) || [];
  const first = imgs.find((u) => !_isPlaceholderUrl(u));
  return first || NO_PHOTO_PLACEHOLDER;
};

